<template>
    <div>

        <div class="kqf-card  mg10 search-box mt20">
            <el-form :inline="true" size="mini">
                <el-form-item label="账号">
                    <el-input v-model="search.username" placeholder="账号"></el-input>
                </el-form-item>
                <el-form-item label="锁定">
                    <el-select v-model="search.is_lock" @input="getList(1)">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="锁定" :value="1"></el-option>
                        <el-option label="未锁定" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList(1)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div  class="kqf-card mg10 pd10 mt20" v-loading="loading">
            <el-table
                    height="calc(100vh - 280px)"
                    border
                    ref="multipleTable"
                    :data="datas.list"
                    tooltip-effect="dark"
                    style="width: 100%"
            >
                <el-table-column
                    width="80"
                        prop="admin_id"
                        label="ID"
                         align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="username"
                        label="用户名"
                         align="center"
                >
                </el-table-column>
                <el-table-column
                        prop="mobile"
                        label="手机号"
                        align="center"
                >
                </el-table-column>
                <el-table-column
                        width="100"
                        prop="role"
                        label="状态"
                         align="center"
                >
                    <template slot-scope="scope" >
                        <el-switch :disabled="scope.row.admin_id == 1" :inactive-value="1" :active-value="0"
                                   :value="scope.row.is_lock" @input="setLock(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="role"
                        label="登录"
                >
                    <template slot-scope="scope">
                        {{scope.row.last_time}} -- {{scope.row.last_ip}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="role"
                        label="创建"
                >
                    <template slot-scope="scope">
                        {{scope.row.create_time}} -- {{scope.row.create_ip}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" >
                    <template slot-scope="scope">
                        <el-button icon="el-icon-edit" type="primary" size="mini" @click="editEnv(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="flex space mt10">
                <div>
                    <el-button type="primary" size="small" @click="createEnv">创建管理员</el-button>
                </div>
                <div>
                    <el-pagination
                            @current-change="getList"
                            background
                            :page-size="datas.limit"
                            layout="total, prev, pager, next"
                            :total="datas.count">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!--  添加弹窗-->
        <el-dialog
                title="创建管理员"
                :visible.sync="createDialog"
                width="600px"
                
               
        >
            <el-form label-width="140px" v-loading="createLoading">
                <el-form-item label="名字：">
                    <el-input v-model="createForm.username"></el-input>
                    <p class="form-tip">不可重复 可以是中文</p>
                </el-form-item>
                <el-form-item label="号码：">
                    <el-input v-model="createForm.mobile"></el-input>
                </el-form-item>
                <el-form-item label="密码：">
                    <el-input type="password" v-model="createForm.password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：">
                    <el-input type="password" v-model="createForm.password2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="medium" @click="createAdmin">创建管理员</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>


        <el-dialog
                title="编辑管理员"
                :visible.sync="editDialog"
                width="600px"
        >
            <el-form label-width="100px" v-loading="editLoading">
                <el-form-item label="名字：">
                    <el-input v-model="editForm.username"></el-input>
                    <p class="form-tip">不可重复 可以是中文</p>
                </el-form-item>
                <el-form-item label="号码：">
                    <el-input v-model="editForm.mobile"></el-input>
                </el-form-item>
                <el-form-item label="密码：">
                    <el-input type="password" v-model="editForm.password"></el-input>
                    <p class="form-tip">不修改密码 留空</p>
                </el-form-item>
                <el-form-item label="确认密码：">
                    <el-input type="password" v-model="editForm.password2"></el-input>
                    <p class="form-tip">不修改密码 留空</p>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="editAdmin">提交修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import {adminIndex, adminLock, adminCreate, adminEdit} from "../../request/api/admin";
    export default {
        data() {
            return {
                loading: true,
                search: {
                    username: '',
                    is_lock: -1,
                    page: 1,
                },
                datas: [],
                createDialog: false,
                createLoading: false,
                createForm: {
                    username: '',
                    mobile:'',
                    password: '',
                    password2: '',
                },
                editDialog: false,
                editLoading: false,
                editForm: {
                    admin_id:0,
                    username: '',
                    mobile:'',
                    password: '',
                    password2: '',
                },
            }
        },
        created() {
            this.getList();
        },
        methods: {
            editEnv(row){
                this.editDialog = true;
                this.editForm = row;
            },
            createEnv() {
                this.createForm = {
                    username: '',
                    mobile:'',
                    password: '',
                    password2: '',
                };
                this.createDialog = true;
            },
            editAdmin(){
                if (this.editForm.password != this.editForm.password2) {
                    this.$message.warning("两次密码不一致");
                    return false;
                }
                this.editLoading = true;
                adminEdit({
                    admin_id:this.editForm.admin_id,
                    name: this.editForm.username,
                    password: this.editForm.password,
                    mobile:this.editForm.mobile,
                }).then(() => {
                    this.editDialog = false
                  this.getList(this.search.page);
                    this.editLoading = false;
                }).catch(() => {
                    this.editLoading = false;
                });
            },
            createAdmin() {
                if (this.createForm.password != this.createForm.password2) {
                    this.$message.warning("两次密码不一致");
                    return false;
                }
                this.createLoading = true;
                adminCreate({
                    name: this.createForm.username,
                    password: this.createForm.password,
                    mobile:this.createForm.mobile,
                }).then(() => {
                    this.createDialog = false
                    this.getList(1);
                    this.createLoading = false;
                }).catch(() => {
                    this.createLoading = false;
                });
            },

            setLock(row) {
                this.loading = true;
                adminLock({admin_id: row.admin_id}).then(() => {
                    row.is_lock ^= 1;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                })
            },
            getList(page = 1) {
                this.loading = true;
                this.search.page = page;
                adminIndex(this.search).then(res => {
                    this.datas = res;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                })
            },
        }
    }
</script>